<template>
    <section class="content-right">
        <div class="chart-box">
            <h3 class="chart-title">内容建设数据</h3>
            <div class="chart-map chart-resource" ref="resourceChart"></div>
        </div>

        <div class="chart-box">
            <h3 class="chart-title">培训总览</h3>
            <div class="chart-map chart-online" ref="onlineChart">
                <div class="online-item" v-for="(item, index) in onlineData" :key="index">
                    <div class="title">
                        <h4 class="title-name">{{item.name}}</h4>
                        <span class="title-num">{{item.value}}</span>
                    </div>
                    <div class="progress-bar">
                        <div class="progress-bar-inner" :style="{width: (item.value/max*100).toFixed(0)+'%'}"></div>
                    </div>
                </div>
            </div>
        </div>

        <div class="chart-box">
            <h3 class="chart-title">上传数量排名</h3>
            <div class="chart-map chart-count" ref="countChart"></div>
        </div>
    </section>
</template>

<script>
    export default {
        components: {},

        data() {
            return {
                onlineData: [],
                max: null
            }
        },

        computed: {},

        mounted() {
            this.initResourceChart()
            this.initOnlineChart()
            this.initCountChart()
        },

        methods: {
            async initResourceChart() {
                this.resourceChart = echarts.init(this.$refs.resourceChart)

                this.resourceChart.showLoading({
                    text: '',
                    maskColor: 'rgba(97,197,255,.1)',
                })

                let res = await this.$api.getMonitorResourceOverview()
                let data = res.package
                let [innerData, mainData] = [data.innerRing[0], data.outerRing]

                this.resourceChart.hideLoading()

                let option = {
                    baseOption: {
                        tooltip: {
                            trigger: 'item'
                        },
                        title: {
                            text: `{val|${innerData.value}}\n{name|${innerData.name}}`,
                            top: 'center',
                            left: 'center',
                            grid: {
                                show: false,
                                left: '10%',
                                right: '10%',
                                bottom: '10%',
                                top: '10%',
                            },
                            textStyle: {
                                rich: {
                                    val: {
                                        fontSize: 28,
                                        fontWeight: 'bold',
                                        color: '#F8D041',
                                    },
                                    name: {
                                        fontSize: 12,
                                        fontWeight: 'normal',
                                        color: '#fff',
                                    }
                                }
                            }
                        },
                        series: [
                            {
                                name: '数量',
                                type: 'pie',
                                radius: ['50%', '70%'],
                                avoidLabelOverlap: false,
                                color: ['#27E9CB', '#FD895B', '#EDAF55', '#1FCAE8', '#236BD7'],
                                label: {
                                    formatter: '{b} {c}',
                                    fontSize: 14
                                },
                                center: ['50%', '50%'],
                                data: mainData
                            }
                        ]
                    },
                    media: [{
                        query: {
                            maxWidth: 320,
                        },
                        option: {
                            title: {
                                textStyle: {
                                    rich: {
                                        val: {
                                            fontSize: 16,
                                        },
                                        name: {
                                            fontSize: 10,
                                        }
                                    }
                                }
                            },
                            series: [
                                {
                                    radius: ['50%', '65%'],
                                    label: {
                                        formatter: '{b} {c}',
                                        fontSize: 10
                                    },
                                }
                            ]
                        }
                    }]
                }

                this.resourceChart.setOption(option)
            },

            async initOnlineChart() {
                let res = await this.$api.getMonitorOverview()
                this.onlineData = res.package || {}
                let valueArr = this.onlineData.map(item => item.value).sort((a,b) => b-a)
                setTimeout(() => {
                    this.max = valueArr[0]
                }, 50)
            },

            async initCountChart() {
                this.countChart = echarts.init(this.$refs.countChart)

                this.countChart.showLoading({
                    text: '',
                    maskColor: 'rgba(97,197,255,.1)',
                })

                let res = await this.$api.getMonitorResourceRank()
                let data = res.package
                let nameArr = data.map(item => item.name)
                let valueArr = data.map(item => item.value)

                this.countChart.hideLoading()

                let option = {
                    tooltip: {
                        trigger: 'axis'
                    },
                    grid: {
                        show: false,
                        left: '10%',
                        right: '10%',
                        bottom: '10%',
                        top: '10%',
                        containLabel: true
                    },
                    xAxis: {
                        type: 'category',
                        data: nameArr,
                        splitLine: { //坐标轴在 grid 区域中的分隔线。
                            show: true,
                            lineStyle: {
                                color: 'rgba(255,255,255,.1)',
                            }
                        },
                    },
                    yAxis: {
                        type: 'value',
                        splitLine: { //坐标轴在 grid 区域中的分隔线。
                            show: true,
                            lineStyle: {
                                color: 'rgba(255,255,255,.1)',
                            }
                        },
                    },
                    dataZoom: [
                        {
                            type: 'inside'
                        }
                    ],
                    textStyle: {
                        color: '#ccc'
                    },
                    series: [{
                        data: valueArr,
                        type: 'line',
                        lineStyle: {
                            color: '#7DCFFE',
                        },
                        areaStyle: {
                            color: 'rgba(65,190,255,.3)'
                        },
                    }]
                }

                this.countChart.setOption(option)
            },

            resizeChart() {
                this.resourceChart.resize()
                this.countChart.resize()
            }
        },
    }
</script>

<style lang="scss">
    @import "~@/style/const";

    .m-monitorScreen {

        .content-right {
            //flex: 2;
            width: 46vh;
            display: flex;
            flex-direction: column;

            .chart-box {
                flex: 1;
                margin-bottom: 1vh;
                padding: 50px 20px 10px 15px;
            }
        }

        .chart-online {
            padding-top: 10px;
            overflow: auto;

            .online-item {
                width: 75%;
                margin: 0 auto 15px auto;

                .title {
                    display: flex;
                    justify-content: space-between;
                    margin-bottom: 5px;
                    font-size: .14rem;
                }

                .title-name {
                    color: #8CD0FF;
                }

                .title-num {
                    color: #E59700;
                    letter-spacing: 1px;
                }

                .progress-bar {
                    height: 20px;
                    display: flex;
                    align-items: center;
                    border: 1px solid rgba(10, 113, 153, 1);
                    border-radius: 12px;

                    .progress-bar-inner {
                        width: 0;
                        height: 12px;
                        border-radius: 12px;
                        background: linear-gradient(90deg, rgba(0, 42, 100, 1), rgba(123, 210, 255, 1));
                        transition: all .6s;
                    }
                }
            }
        }
    }
</style>
